import { useEntityDetailsDataStore } from '../use-entity-details-data-store';

export const useEntityData = () => {
  const data = useEntityDetailsDataStore((state) => state.entityData);
  return data;
};
